var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"px-6 mb-4",attrs:{"color":"blue-grey lighten-1","width":"230","rounded":""},on:{"click":_vm.authorizeSpotify}},[_vm._v("Continue as Guest")])}
var staticRenderFns = []

export { render, staticRenderFns }